// ErrorBoundary.jsx -- Sprint Hub PD22-S1v2
// ASCII only. No Unicode.
import React, { Component } from 'react';

var RELOAD_KEY = 'hub_reload_attempted';
var BUG_REPORT_URL = '/api/brief/bug-report';

function postBugReport(error) {
  try {
    var userEmail = 'unknown';
    try { userEmail = localStorage.getItem('hub_user_email') || 'unknown'; } catch(e) {}
    var description = '[AUTO] ErrorBoundary crash: ' + (error && error.message ? error.message : 'unknown') +
      ' | Stack: ' + (error && error.stack ? error.stack.substring(0, 500) : 'none');
    fetch(BUG_REPORT_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ description: description, page: window.location.href })
    }).catch(function() {});
  } catch(e) {}
}

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error: error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[Sprint Hub] Error caught by boundary:', error, errorInfo);
    var msg = error && error.message ? error.message : '';
    var isChunkLoad = msg.indexOf('dynamically imported module') >= 0 ||
      msg.indexOf('Failed to fetch') >= 0 ||
      msg.indexOf('Importing a module script failed') >= 0;
    if (!isChunkLoad) {
      postBugReport(error);
    }
  }

  render() {
    if (this.state.hasError) {
      var isDark = false;
      try { isDark = document.body.classList.contains('dark-mode'); } catch(e) {}
      // Chunk-load path colors
      var chunkBg = isDark ? '#12110f' : '#f8f7f4';
      var chunkText = isDark ? '#E2E8F0' : '#12110f';
      var chunkMuted = isDark ? '#b0ada5' : '#6b6962';
      // General crash path colors
      var crashTitle = isDark ? '#E2E8F0' : '#0F172A';
      var crashMuted = isDark ? '#94A3B8' : '#64748B';
      var crashBorder = isDark ? '#262A36' : '#E2E8F0';
      var crashBtnBg = isDark ? '#1c1b18' : '#fff';
      var crashBtnText = isDark ? '#E2E8F0' : 'inherit';
      var crashCardBg = isDark ? '#1E293B' : '#F8FAFC';
      var crashOuterBg = isDark ? '#12110f' : '#FFFFFF';

      // Auto-reload on chunk load failure (stale deploy -- new version deployed while user was on old bundle)
      var msg = this.state.error && this.state.error.message ? this.state.error.message : '';
      if (msg.indexOf('dynamically imported module') >= 0 || msg.indexOf('Failed to fetch') >= 0 || msg.indexOf('Importing a module script failed') >= 0) {
        try {
          if (!sessionStorage.getItem(RELOAD_KEY)) {
            sessionStorage.setItem(RELOAD_KEY, '1');
            window.location.reload(true);
            return null;
          }
          // Already tried reload -- show friendly update message
          sessionStorage.removeItem(RELOAD_KEY);
        } catch(e) {}
        return (
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            height: '100vh', background: chunkBg, color: chunkText,
            fontFamily: "'IBM Plex Sans', sans-serif", flexDirection: 'column', gap: 16
          }}>
            <div style={{ fontSize: 18, fontWeight: 600 }}>Hub just updated</div>
            <div style={{ fontSize: 13, color: chunkMuted, textAlign: 'center', maxWidth: 320 }}>
              A new version was deployed. Refresh to load the latest.
            </div>
            <button
              onClick={function() {
                try { sessionStorage.removeItem(RELOAD_KEY); } catch(e) {}
                window.location.reload(true);
              }}
              style={{
                marginTop: 8, padding: '10px 24px', borderRadius: 8,
                background: '#4F6EF7', color: '#fff', border: 'none',
                fontSize: 14, fontWeight: 600, cursor: 'pointer',
                fontFamily: "'IBM Plex Sans', sans-serif"
              }}
            >Refresh now</button>
          </div>
        );
      }

      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', padding: 48, textAlign: 'center',
          background: crashOuterBg, minHeight: '100%', fontFamily: "'IBM Plex Sans', sans-serif"
        }}>
          <div style={{
            background: crashCardBg, borderRadius: 12, padding: '32px 40px',
            maxWidth: 460, width: '100%', border: '1px solid ' + crashBorder
          }}>
            <div style={{ fontSize: 40, marginBottom: 12, color: crashMuted }}>!</div>
            <div style={{ fontSize: 16, fontWeight: 600, color: crashTitle, marginBottom: 8 }}>
              Something unexpected happened
            </div>
            <div style={{ fontSize: 13, color: crashMuted, marginBottom: 24 }}>
              We're looking into it. Try reloading or head back to your Brief.
            </div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
              <button
                onClick={function() { window.location.reload(); }}
                style={{
                  padding: '8px 20px', borderRadius: 8,
                  border: '1px solid ' + crashBorder,
                  background: crashBtnBg, color: crashBtnText, fontSize: 13, cursor: 'pointer',
                  fontWeight: 500, fontFamily: "'IBM Plex Sans', sans-serif"
                }}
              >Reload Page</button>
              <button
                onClick={function() { window.location.href = '/brief'; }}
                style={{
                  padding: '8px 20px', borderRadius: 8, border: 'none',
                  background: '#4F6EF7', color: '#fff', fontSize: 13, cursor: 'pointer',
                  fontWeight: 500, fontFamily: "'IBM Plex Sans', sans-serif"
                }}
              >Go to Brief</button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
